export default [
    {
        path: '/payment-verification/:paymentIntentId?',
        name: 'payment.verification',
        meta: {
            middleware: {
                mustBeAuthenticated: true,
                redirectBackAfterLogin: true
            }
        },
        components: {
            default: () => import('../views/public/paymentVerification/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
    }
]
